import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoIcon from '@ui-components-3/icons/lib/regular/CircleInfo'
import OperatingHoursModal from './OperatingHoursModal'
import { OperatingHoursRange } from 'hooks/operating-hours/types'

type OperatingHoursInfoProps = {
  baseDate: Date
  operatingHoursRanges: OperatingHoursRange[]
}

const OperatingHoursInfo = ({ baseDate, operatingHoursRanges }: OperatingHoursInfoProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const { t } = useTranslation()

  const toggleModal = useCallback(
    (_isVisible: boolean) => () => {
      setIsModalVisible(_isVisible)
    },
    [],
  )

  return (
    <>
      <button type="button" onClick={toggleModal(true)} className="btn-sm btn-neutral-borderless !typography-body px-0">
        {t('operatingHours.currentlyUnavailable')}
        <InfoIcon className="text-primary-600" aria-hidden="true" />
      </button>
      {!!isModalVisible && (
        <OperatingHoursModal
          onClose={toggleModal(false)}
          operatingHoursRanges={operatingHoursRanges}
          baseDate={baseDate}
        />
      )}
    </>
  )
}

export default OperatingHoursInfo
